import React from 'react';
import { Box, Image, Text, Center } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box py={4} borderTopWidth="1px" borderColor="gray.200">
      <Center flexDirection="column">
        <Image 
          src="/letsparky-logo.png" 
          alt={t('footer.logoAlt')} 
          width={40}
        />
        <Text mt={2} fontSize="xs" color="gray.500">
          {t('footer.poweredBy')}
        </Text>
      </Center>
    </Box>
  );
};

export default Footer; 